/**
 * @owner @Appboy/messaging-experience
 */

import { purchaseRemoteLookupValidators } from "@schemas/remoteLookup/purchaseRemoteLookupSchema";
import type { PurchaseRemoteLookupId, PurchaseRemoteLookupItem, PurchaseRemoteLookupFilters } from "@schemas/types";

import type { RemoteLookupProvider } from "./types";

export const purchaseProvider: RemoteLookupProvider<
  PurchaseRemoteLookupId,
  PurchaseRemoteLookupItem,
  PurchaseRemoteLookupFilters
> = {
  mapItemToId: (item) => item.indexed_name,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: purchaseRemoteLookupValidators,
};
